import { Flex, Text } from '@chakra-ui/react';
import { Tag } from '@foam/buoy/src/components/Tag/Tag';
import { PersonIcon } from 'ui-components/dist/PersonIcon';
import { CategoryTag as Vertical } from '~/components/CategoryTag/CategoryTag.model';
import { Chip } from '~/components/Chip';
import { CloseIconNew } from '~/components/icons';
import { useCreatorsFiltersStore } from '~/screens/MyAgency/store';

const BaseChip: React.FC<{
  text: string;
  onClear: () => void;
  newFilterPill?: boolean;
}> = ({ text, onClear, newFilterPill }) => {
  if (newFilterPill) {
    return (
      <Tag variant="secondary" onClose={onClear} size="sm" iconPrefix="Person">
        {text}
      </Tag>
    );
  }

  return (
    <Chip rightIcon={<CloseIconNew />} onRightIconClick={onClear}>
      <Flex
        alignItems="center"
        color={newFilterPill ? undefined : 'primary.400'}
        gap={1.5}
      >
        <PersonIcon height={4} width={4} />
        <Text>{text}</Text>
      </Flex>
    </Chip>
  );
};

export const AppliedCreatorFilters = ({
  newFilterPill,
}: {
  newFilterPill?: boolean;
}) => {
  const { verticals, gender, age, locationAppliedFilter, clearFilter } =
    useCreatorsFiltersStore();

  return (
    <>
      {/* Render verticals as pills */}
      {verticals.map((v: Vertical) => (
        <BaseChip
          key={`vertical-${v}`}
          text={`Verticals: ${v}`}
          onClear={() => clearFilter('verticals', v)}
          newFilterPill={newFilterPill}
        />
      ))}

      {/* Render Gender as pill */}
      {gender ? (
        <BaseChip
          key={`gender-${gender}`}
          text={`Gender: ${gender}`}
          onClear={() => clearFilter('gender')}
          newFilterPill={newFilterPill}
        />
      ) : null}

      {/* Render Age as pill */}
      {age ? (
        <BaseChip
          key={`age-${age}`}
          text={`Age: ${age.replace(':', '-')}`}
          onClear={() => clearFilter('age')}
          newFilterPill={newFilterPill}
        />
      ) : null}

      {/* Render Location as pill */}
      {locationAppliedFilter ? (
        <BaseChip
          key={`location-${locationAppliedFilter}`}
          text={`Location: ${locationAppliedFilter}`}
          onClear={() => clearFilter('location')}
          newFilterPill={newFilterPill}
        />
      ) : null}
    </>
  );
};
